// extracted by mini-css-extract-plugin
export default {"counter":"AgreementForm_counter__ArtS1"};